
function NavItem({ section, label }) {
  return (
    <li >
      <a
        href={section}
        className="hover:text-yellow-300 transition duration-300 px-3 py-2 rounded-md"
      >
        {label}
      </a>
    </li>
  );
}

export default NavItem;
